/**
 * Created by razial on 15.04.2024.
 */

Mission.TYPE_TREASURE_SEARCH = 7;

Mission.REGISTRATIONS.set(Mission.TYPE_TREASURE_SEARCH, () => ({
    available: cleverapps.config.availables.TREASURE_SEARCH_MISSION,
    name: "tsearch",
    view: TreasureSearchWindow,
    minigame: {
        price: 1
    },
    teaser: true,
    startWindow: TreasureSearchWindow,
    tutorialScenario: TreasureSearchTutorial.NAME,
    collectIcon: bundles.reward_icons.frames.reward_shovel_png,
    guideWindow: {
        name: "tsearchGuideWindow",
        bundle: bundles.tsearchguidewindow
    },
    nudgeWindow: TreasureSearchWindow,
    schedule: "MON-FRI",
    semaphore: Mission.SEMAPHORE_ALWAYS,
    bundle: "treasuresearch",
    sideBarJson: bundles.sidebar.jsons.treasure_search_icon_json,
    rowView: cleverapps.config.type === "merge2" ? function (row) {
        return Prefab.instantiate(bundles.questsgroupicon.jsons.treasure_search_row_prefab_json, { mission: row.data.mission });
    } : undefined,
    logic: TreasureSearchMissionLogic,
    startCurrency: 2
}));

cleverapps.InitByFeature["treasure_search"] = function () {
    cleverapps.tutorial.register(TreasureSearchTutorial());
};

RewardTypes.mission.icon[Mission.TYPE_TREASURE_SEARCH] = bundles.reward_icons.frames.reward_shovel_png;